module.exports = __webpack_public_path__ + "img/organizationMgt.d70d118b.svg";